import React, { StrictMode } from 'react'
import ReactDOM, { createRoot } from 'react-dom/client'
import './index.css'
import './App.css'
import App from './App'
import Interceptor from '@/lib/networkExtensions/network.interceptor'
import axe from '@axe-core/react'

Interceptor.interceptor()

if (process.env.NODE_ENV !== 'production') {
  axe(React, ReactDOM, 1000)
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
)
